import React from 'react';
import { MenuItem, TextField, Tooltip } from '@material-ui/core';
import { AlphanumericRegex } from '../../constants';

const InputField = (props: any) => {
   return (
      <>
         {props.options ? (
            <TextField
               {...props}
               select
               id={props.id}
               // margin="normal"
               label={props.label}
               error={props.error}
               helperText={props.helperText}
            >
               <MenuItem></MenuItem>
               {props.options.map((option: any, index: number) => (
                  <MenuItem value={option.value} key={index}>
                     {option.label}
                  </MenuItem>
               ))}
            </TextField>
         ) : (
            <TextField
               {...props}
               name={props?.name}
               id={props.id}
               type={props.type}
               label={props.label}
               variant={props.variant}
               error={props.error}
               helperText={props.helperText}
               InputProps={props.InputProps}
               inputProps={props.inputProps}
            />
         )}
      </>
   );
};

export default InputField;
